import FormularioList from "./FormularioList.vue";
import FormularioGanado from "./ganado/FormularioGanado.vue";
import FormularioAves from "./aves/FormularioAves.vue";
import FormularioPerros from "./perros/FormularioPerros.vue";

export default [
  {
    path: "/formularios",
    name: "formularios",
    component: FormularioList,
    meta: {
      titulo: "Lista de ataques que he registrado",
      menu: "Formularios",
      icono: "fal fa-fw fa-file-alt",
    },
  },
  {
    path: "/formularios/ganado",
    name: "ganado",
    component: FormularioGanado,
    meta: {
      titulo: "Formulario para Ganado",
      icono: "fal fa-fw fa-cow",
      esconder: true,
    },
  },
  {
    path: "/formularios/aves",
    name: "aves",
    component: FormularioAves,
    meta: {
      titulo: "Formulario para Aves",
      icono: "fal fa-fw fa-kiwi-bird",
      esconder: true,
    },
  },
  {
    path: "/formularios/perros",
    name: "perros",
    component: FormularioPerros,
    meta: {
      titulo: "Formulario para Perros",
      icono: "fal fa-fw fa-dog",
      esconder: true,
    },
  },
];
